// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--light.v-application[data-v-844dd758] {\n  background: #ffffff !important;\n}\n.unauthorized-container[data-v-844dd758] {\n  height: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
